import {
  Box,
  Card,
  CardContent,
  CardMedia,
  LinearProgress,
  Typography,
} from "@mui/material";
import { FC } from "react";
import styled from "styled-components";

type DisplayProblemProps = {
  immediateCheck?: boolean;
  isCorrect: boolean;
  remainingTime: number;
  timeLimit: number;
  imgUrl: string;
  nowPoint: number;
};

export const DisplayProblem: FC<DisplayProblemProps> = (props) => {
  const {
    immediateCheck,
    isCorrect,
    remainingTime,
    timeLimit,
    imgUrl,
    nowPoint,
  } = props;
  const str = immediateCheck ? (isCorrect ? "正解" : "未正解") : "?";
  const progress = (remainingTime / timeLimit) * 100;
  return (
    <ProbWrapper>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body1" color="text.primary">{`${(
            "0" + Math.floor(remainingTime / 60)
          ).slice(-2)}:${("0" + Math.floor(remainingTime % 60)).slice(
            -2
          )}`}</Typography>
        </Box>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      </Box>
      {/*
        <p>
          得点計算式：{baseScore} + {scoreTimeCoefficient} × (残り時間)
        </p>
        <p>即時判定：{String(immediateCheck)}</p>
        <p>現在の提出：{playerAnswer}</p>
        <p>正誤判定：{str}</p>
        */}
      <p>{nowPoint.toFixed(0)} point</p>
      <br />
      {imgUrl && remainingTime > 0 && (
        <Card sx={{ width: "92vw", height: "69vw" }}>
          <CardMedia>
            <ProblemImg src={imgUrl} alt="Problem" />
          </CardMedia>
          <CardContent>
            {/*
                              <Typography variant="h3" color="text.primary">
                  {problemState}
                </Typography>
                   */}
          </CardContent>
        </Card>
      )}
      {remainingTime <= 0 && (
        <Typography variant="h3" sx={{ textAlign: "center" }}>
          制限時間が終了しました
        </Typography>
      )}

      <br />
    </ProbWrapper>
  );
};

const ProbWrapper = styled.div`
  user-select: none;
`;

const ProblemImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
